import {charcoal} from '../sass/base/_exports.sass';

export const CircleIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox="0 0 100 100"
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 50A45 45 0 1 0 95 50A45 45 0 1 0 5 50" fill={color} />
    </svg>
  );
};
